import { RootState } from "../store/store";

export const accountRedeferralStatusesSelector = (state: RootState) =>
  state.accountRedeferralStatuses.accountRedeferralStatuses;

export const redeferralInstructionDtosSelector = (state: RootState) =>
  state.redeferrals.redeferralInstructionDtos;
